// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { CStamp_abstract } from './../abstract/SagaSchema/CStamp_abstract';
import { CallCard } from './CallCard';
export class CStamp extends CStamp_abstract {
  callcard: CallCard;
}
